import { pricingConfig } from '../data/pricing';
import type { CartLine } from '../types/cart';
import { buildCheckoutUrl, normalizeOrder } from './checkout';
import type { OrderLine } from './checkout';

export type PermalinkResult = { url: string | null; missing: string[] };

/** Converts saved cart lines into official Shopify systems. Loose lights use the Single Light variant. */
export function cartToOrder(lines: CartLine[]): OrderLine[] {
  return normalizeOrder(
    lines.map((l) =>
      l.kind === 'individual' ? { bundleId: 'sys1' as const, qty: l.qty } : { bundleId: l.bundleId, qty: 1 },
    ),
  );
}

/** Builds the live Shopify cart permalink for the saved cart. */
export function buildCartPermalink(lines: CartLine[]): PermalinkResult {
  const missing = pricingConfig.bundles.filter((b) => !b.variantId).map((b) => `variantId.${b.id}`);
  if (!lines.length) return { url: null, missing };
  return { url: missing.length ? null : buildCheckoutUrl(cartToOrder(lines)), missing };
}
